import { render, staticRenderFns } from "./SelectGrupo.vue?vue&type=template&id=2a396e30&scoped=true"
import script from "./SelectGrupo.vue?vue&type=script&lang=js"
export * from "./SelectGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a396e30",
  null
  
)

export default component.exports